import { useEffect, useState } from 'react';
import OrderHistory from './OrderHistory';
import TransactionHistory from './TransactionHistory';
import { useNavigate, useParams } from 'react-router-dom';
import { callApi } from '../../services/ApiServices';
import { formatTimestamp, formatTimestampWithTime } from '../../utlis/function';
import CommonLoader from '../common/CommonLoader';

const AdvertiserDetail = () => {
  
  const [adviserData, setAdvertiserData] = useState([])
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const {id} = useParams()

  useEffect(()=>{
    if(id){
      fetchAdertiserDetails(id)
    }
  },[id])


const fetchAdertiserDetails = async()=>{
  setLoading(true)
  try{
  const res = await callApi({
    method:"get",
    url:`admin/advertiser-detail/${id}`
  })
  if(res.status === 200){
    setAdvertiserData(res?.data)
    }
  }catch(error){
    console.log("error while fetching advertiser details", error)
  }finally{
    setLoading(false)
  }
}

  const handleBackToList = () => {
   navigate('/advertiser')
  };

  return (
    <div className="space-y-6">
      {loading && <CommonLoader fullScreen />}
      <button
        onClick={handleBackToList}
        className="flex items-center gap-2 text-primary hover:text-hover transition-colors"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 18l-6-6 6-6"
          />
        </svg>
        <span className="text-base font-medium cursor-pointer">Back to Advertisers</span>
      </button>
      {/* Basic Details Section */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-6">
        <h2 className="text-xl font-medium text-black mb-6 pb-4 border-b border-gray-200">
          Basic Details
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Name Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Name
            </label>
            <input
              type="text"
              value={adviserData?.user?.name || "-"}
              disabled
              className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
            />
          </div>

          {/* Email Address Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Email Address
            </label>
            <input
              type="email"
              disabled
              value={adviserData?.user?.email || "-"}
              className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
            />
          </div>

          {/* Contact Number Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Contact Number
            </label>
            <input
              type="tel"
              disabled
              value={adviserData?.user?.phoneCode || adviserData?.user?.phoneNumber? `${adviserData?.user?.phoneCode || ""} ${adviserData?.user?.phoneNumber || ""}`: "-"}
              className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
            />
          </div>
        </div>
      </div>

      {/* Account Summary Section */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-6">
        <h2 className="text-xl font-medium text-black mb-6 pb-4 border-b border-gray-200">
          Account Summary
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {/* Total Orders Card */}
          <div className="bg-[#d4f4fb] rounded-lg p-6">
            <p className="text-base font-normal text-textcolor mb-2">
              Total Orders
            </p>
            <p className="text-[20px] font-medium text-black">
            {adviserData?.accountSummary?.totalOrders || 0}
            </p>
          </div>

          {/* Active Campaigns Card */}
          <div className="bg-[#d4f4d7] rounded-lg p-6">
            <p className="text-base font-normal text-textcolor mb-2">
              Active Campaigns
            </p>
            <p className="text-[20px] font-medium text-black">
               {adviserData?.accountSummary?.activeCampaigns || 0}
            </p>
          </div>

          {/* Total Spent Card */}
          <div className="bg-[#fde9e4] rounded-lg p-6">
            <p className="text-base font-normal text-textcolor mb-2">
              Total Spent
            </p>
            <p className="text-[20px] font-medium text-black">
           {adviserData?.accountSummary?.totalSpent ? `$${adviserData?.accountSummary?.totalSpent}` : "$0.00"}
            </p>
          </div>

          {/* Avg. Monthly Spend Card */}
          <div className="bg-[#e8dff5] rounded-lg p-6">
            <p className="text-base font-normal text-textcolor mb-2">
              Avg. Monthly Spend
            </p>
            <p className="text-[20px] font-medium text-black">
         {adviserData?.accountSummary?.monthlySpend ? `$${adviserData?.accountSummary?.monthlySpend}` : "$0.00"}
            </p>
          </div>
        </div>
      </div>

      {/* Activity Log Section */}
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] p-6">
        <h2 className="text-xl font-medium text-black mb-6 pb-4 border-b border-gray-200">
          Activity Log
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Last Login Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Last Login
            </label>
            <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
             {formatTimestampWithTime(adviserData?.activeLog?.lastLogin)}
            </div>
          </div>

          {/* Last Order Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Last Order
            </label>
            <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
           {formatTimestampWithTime(adviserData?.activeLog?.lastOrder)}
            </div>
          </div>

          {/* Last Payment Field */}
          <div className="flex flex-col gap-2">
            <label className="text-lg font-normal text-textcolor">
              Last Payment
            </label>
            <div className="px-4 py-3 bg-white border border-gray-200 rounded-lg text-black font-normal text-base">
              {formatTimestampWithTime(adviserData?.activeLog?.lastPayment)}
            </div>
          </div>
        </div>
      </div>

      {/* Order History Section */}
      <OrderHistory  />

      {/* Transaction History Section */}
      <TransactionHistory />
    </div>
    // ----Single Advertiser Page Ends---->>

    // ---Main Advertiser Page Starts -->>

  );
};

export default AdvertiserDetail;
